import React from 'react';
import { motion } from 'framer-motion';
import MasonryGrid from '../components/MasonryGrid';
import { portfolioItems } from '../data/portfolioData';
const PhotoPortfolio = () => {
  const photoItems = portfolioItems.filter(item => {
    if (Array.isArray(item.category)) {
      return item.category.includes('Photo');
    }
    return item.category === 'Photo';
  });
  return <motion.div className="p-6" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.5
  }} data-id="element-318">
      {photoItems.length === 0 ? <div className="flex flex-col items-center justify-center min-h-[50vh] text-center" data-id="element-319">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-320">
            No Photos Yet
          </h2>
          <p className="text-gray-600" data-id="element-321">Check back soon for photo content!</p>
        </div> : <MasonryGrid items={photoItems} data-id="element-322" />}
    </motion.div>;
};
export default PhotoPortfolio;